import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthValidation } from '../hooks/useAuthValidation';

const Dashboard = () => {
  useAuthValidation();
  return (
    <div className="dashboard">
      <div className="row">
        <div className="col-12">
          <div className="jumbotron bg-light p-5 rounded-3">
            <h1 className="display-4">Sistema de Gestión de Comprobantes</h1>
            <p className="lead">
              Plataforma para el registro y exportación de comprobantes según las
              especificaciones del SET Paraguay
            </p>
            <hr className="my-4" />
            <p>
              Este sistema permite registrar comprobantes de ventas, compras, ingresos y
              egresos para su posterior exportación en el formato requerido por la
              Subsecretaría de Estado de Tributación.
            </p>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        {/* New Comprobante Card */}
        <div className="col-md-4 mb-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-plus-circle text-primary" style={{ fontSize: '3rem' }}></i>
              <h5 className="card-title mt-3">Nuevo Comprobante</h5>
              <p className="card-text">
                Registre nuevos comprobantes de ventas, compras, ingresos o egresos.
              </p>
              <Link to="/comprobantes/new" className="btn btn-primary">
                <i className="bi bi-plus"></i> Crear Comprobante
              </Link>
            </div>
          </div>
        </div>

        {/* List Comprobantes Card */}
        <div className="col-md-4 mb-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-list-ul text-success" style={{ fontSize: '3rem' }}></i>
              <h5 className="card-title mt-3">Ver Listado</h5>
              <p className="card-text">
                Consulte y administre los comprobantes registrados en el sistema.
              </p>
              <Link to="/comprobantes" className="btn btn-success">
                <i className="bi bi-list"></i> Ver Comprobantes
              </Link>
            </div>
          </div>
        </div>

        {/* Export Card */}
        <div className="col-md-4 mb-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-download text-info" style={{ fontSize: '3rem' }}></i>
              <h5 className="card-title mt-3">Exportar Datos</h5>
              <p className="card-text">
                Exporte los comprobantes en formato CSV/TXT para el sistema Marangatu.
              </p>
              <Link to="/comprobantes" className="btn btn-info">
                <i className="bi bi-download"></i> Ir a Exportación
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        {/* Archive History Card */}
        <div className="col-md-6 mb-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-clock-history text-warning" style={{ fontSize: '3rem' }}></i>
              <h5 className="card-title mt-3">Historial de Archivos</h5>
              <p className="card-text">
                Consulte el historial de archivos ZIP generados y enviados al portal DNIT.
              </p>
              <Link to="/archives" className="btn btn-warning">
                <i className="bi bi-clock-history"></i> Ver Historial
              </Link>
            </div>
          </div>
        </div>

        {/* Import Card */}
        <div className="col-md-6 mb-4">
          <div className="card h-100 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-upload text-secondary" style={{ fontSize: '3rem' }}></i>
              <h5 className="card-title mt-3">Importar Datos</h5>
              <p className="card-text">
                Importe comprobantes desde archivos CSV para carga masiva al sistema.
              </p>
              <Link to="/import" className="btn btn-secondary">
                <i className="bi bi-upload"></i> Importar CSV
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Important Information */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-secondary text-white">
              <h5 className="mb-0">
                <i className="bi bi-info-circle"></i> Información Importante
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h6>Tipos de Registros Soportados:</h6>
                  <ul>
                    <li>
                      <strong>Ventas:</strong> Facturas, Notas de Crédito/Débito, Boletas
                    </li>
                    <li>
                      <strong>Compras:</strong> Facturas, Autofacturas, Despachos de
                      Importación
                    </li>
                    <li>
                      <strong>Ingresos:</strong> Liquidaciones de Salario, Comprobantes de
                      Ingreso
                    </li>
                    <li>
                      <strong>Egresos:</strong> Extractos, Transferencias, Comprobantes del
                      Exterior
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h6>Consideraciones:</h6>
                  <ul>
                    <li>No incluir comprobantes del Sistema e-kuatia</li>
                    <li>No incluir Comprobantes Virtuales</li>
                    <li>Los montos se registran sin decimales</li>
                    <li>El RUC se registra sin dígito verificador</li>
                    <li>Formato de archivo: CSV o TXT en UTF-8</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
